var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12405_170252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 2.58398C6.75016 2.58398 2.0835 7.25065 2.0835 13.0007C2.0835 18.7507 6.75016 23.4173 12.5002 23.4173C18.2502 23.4173 22.9168 18.7507 22.9168 13.0007C22.9168 7.25065 18.2502 2.58398 12.5002 2.58398ZM10.4168 18.209L5.2085 13.0007L6.67725 11.5319L10.4168 15.2611L18.3231 7.35482L19.7918 8.83398L10.4168 18.209Z",
    fill: "#505050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12405_170252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedTick);
export default __webpack_public_path__ + "static/media/checked-tick.21dce1c11709d9c4a0f839b9df05ea8f.svg";
export { ForwardRef as ReactComponent };